export class State {
  public error = '';
  public practices = [];
  public practiceCount = 0;
  public dropdownPracticeList = [];
}